import React, { useMemo, useState } from 'react';
import Footer from 'shared/components/footer/Footer';
import 'shared/styles/payment.css';
import {
  Alert,
  ButtonLink,
  FunnelPage,
  FunnelSection,
  SectionHeader,
  StepList,
} from 'shared/components/funnel/FunnelUI';

const paymentInfo = {
  USDT: {
    address: 'TJQJVBwBK8atEJ8SMbRHqTxXqQZwfjpYAG',
    qrCode: '/assets/images/services/vip/USDT.JPG?v=20260911-addresses',
    text: 'SEND USDT ONLY',
    network: 'NETWORK: TRC20',
  },
  SOL: {
    address: 'A9CULeEPwtMQsvHPhFLEbCHDqfRSuQLvkCqLUaqR2pD5',
    qrCode: '/assets/images/services/vip/sol-full.jpg?v=20260911-addresses',
    text: 'SEND SOL ONLY',
    network: 'NETWORK: SOLANA',
  },
  XRP: {
    address: 'r4dPeHxzw2x3X5GvLdYDHRoDsCnCpE1L8d',
    qrCode: '/assets/images/services/vip/xrp-full.jpg?v=20260911-addresses',
    text: 'SEND XRP ONLY',
    network: 'NETWORK: XRP',
    tag: '301277062',
  },
};

const redeemSteps = [
  {
    title: 'Send the payment',
    copy: 'Use only the selected currency and network shown in the panel.',
  },
  {
    title: 'Save the transaction screenshot',
    copy: 'Make sure the address, amount, transaction hash, and time are visible.',
  },
  {
    title: 'Message Telegram admin',
    copy: 'Send the screenshot to CRYPTOXNFT admin for manual VIP redemption.',
  },
];

function Payment2() {
  const [selectedCrypto, setSelectedCrypto] = useState('USDT');
  const [copyStatus, setCopyStatus] = useState('');
  const selected = paymentInfo[selectedCrypto];
  const cryptoOptions = useMemo(() => Object.keys(paymentInfo), []);

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(selected.address);
      setCopyStatus(`${selectedCrypto} address copied.`);
    } catch (error) {
      setCopyStatus('Copy failed. Select the address and copy it manually.');
    }
  };

  return (
    <FunnelPage className="payment-page">
      <FunnelSection tone="hero" className="payment-hero">
        <SectionHeader
          eyebrow="VIP payment"
          title="Lifetime VIP membership"
          copy="Lifetime VIP is 50% off. Pay 578 USDT equivalent instead of 1,159 USDT — save 581 USDT."
        />

        <div className="funnel-payment-panel">
          <div className="funnel-payment-header">
            <div>
              <h2>{selectedCrypto} payment</h2>
              <p>{selected.text} / {selected.network}</p>
            </div>
            <div className="funnel-payment-price vip-sale-price">
              <s className="vip-sale-price__original">1,159 USDT</s>
              <span>578 USDT</span>
              <span className="vip-sale-price__badge">50% OFF</span>
            </div>
          </div>

          <div className="funnel-payment-body">
            <img src={selected.qrCode} alt={`${selectedCrypto} payment QR code`} className="funnel-payment-qr" />
            <div className="funnel-payment-controls">
              <div className="funnel-segmented" aria-label="Select payment currency">
                {cryptoOptions.map((crypto) => (
                  <button
                    key={crypto}
                    type="button"
                    className={selectedCrypto === crypto ? 'is-active' : ''}
                    onClick={() => {
                      setSelectedCrypto(crypto);
                      setCopyStatus('');
                    }}
                  >
                    {crypto}
                  </button>
                ))}
              </div>

              <div className="funnel-address-box">
                <span>Payment address</span>
                <code>{selected.address}</code>
              </div>

              {selected.tag && (
                <div className="funnel-address-box">
                  <span>XRP memo/tag</span>
                  <code>{selected.tag}</code>
                </div>
              )}

              <ButtonLink onClick={handleCopyToClipboard}>Copy Address</ButtonLink>
              <div className="funnel-copy-status" role="status" aria-live="polite">
                {copyStatus}
              </div>
              <Alert tone="warning">
                Sending the wrong asset, network, or missing XRP tag can make the payment unrecoverable.
              </Alert>
            </div>
          </div>
        </div>
      </FunnelSection>

      <FunnelSection tone="muted">
        <div className="payment-redeem-grid">
          <SectionHeader
            align="start"
            eyebrow="Redeem access"
            title="Send a screenshot after payment."
            copy="Access is handled manually. Telegram admin needs visible transaction proof before VIP can be added."
          />
          <div>
            <StepList steps={redeemSteps} />
            <div className="payment-actions">
              <ButtonLink href="https://t.me/cryptoxnftsignals">Send Screenshot</ButtonLink>
              <ButtonLink to="/services/vip" variant="secondary">Back to VIP</ButtonLink>
            </div>
          </div>
        </div>
      </FunnelSection>

      <Footer />
    </FunnelPage>
  );
}

export default Payment2;
